import { EmailPointerParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../constants';

export default (): EmailPointerParameterValue => ({
  type: PARAMETER_VALUE_TYPE.EMAIL_POINTER,
  variable: null,
});
